import { useQuery } from '@tanstack/react-query';
import { fetchMotHistory } from '../services/motHistory';
import type { MotHistoryResponse } from '../types/motHistory.types';

function isRetryable(err: unknown): boolean {
  if (err && typeof err === 'object' && 'response' in err) {
    const status = (err as { response?: { status?: number } }).response?.status;
    return status !== undefined && status !== 404 && status !== 429 && status >= 500;
  }
  return false;
}

export function useMotHistory(
  vin?: string,
  vrm?: string
): ReturnType<typeof useQuery<MotHistoryResponse>> {
  return useQuery<MotHistoryResponse>({
    queryKey: ['mot-history', vin ?? '', vrm ?? ''],
    queryFn: () => fetchMotHistory({ vin: vin || undefined, vrm: vrm || undefined }),
    enabled: Boolean(vin || vrm),
    staleTime: 5 * 60 * 1000,
    retry: (count, err) => isRetryable(err) && count < 1,
  });
}
